var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper-header',[_vm._l((_vm.steps),function(step,index){return [_c('StepSummaryItem',{key:("step-" + index),class:{
                'px-0 mr-6': index === 0,
                'ml-2': index === 1,
                'pr-2': index === _vm.steps.length - 1
            },attrs:{"currentStep":_vm.currentStep,"stepId":(index + 1),"step":step}}),_vm._v(" "),(index < _vm.steps.length - 1)?_c('v-divider',{key:index}):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ef88b91","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myHabiteoStudio/components/StepSummaryItems.vue
// module id = null
// module chunks = 